import { useState } from 'react';
import { useApiChart, useBasis, useCensus, useLatest, useSession, useSnapshot, useStaticChart } from './api/queries';
import { apiOn } from './api/client';
import { useApiState } from './api/state';
import { Census } from './components/Census';
import { Check } from './components/Check';
import { Contracts } from './components/Contracts';
import { Faq } from './components/Faq';
import { FeeQuote } from './components/FeeQuote';
import { FeeTransparency } from './components/FeeTransparency';
import { Footer } from './components/Footer';
import { Gap } from './components/Gap';
import { snapNote } from './lib/basisTable';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Instrument } from './components/Instrument';
import { Status } from './components/Status';
import { Ticker } from './components/Ticker';
import { VerifyToken } from './components/VerifyToken';
import { Who } from './components/Who';

export const DEFAULT_SYMBOL = 'NVDA';

export function App() {
  const [symbol, setSymbol] = useState(DEFAULT_SYMBOL);
  const api = useApiState();
  const snapshot = useSnapshot();
  const latest = useLatest();
  const session = useSession();
  const basis = useBasis();
  const apiChart = useApiChart();
  const staticChart = useStaticChart();
  const census = useCensus();

  const snap = snapshot.data ?? null;
  const nothingLoaded = snapshot.isError && (latest.isError || latest.failureCount > 0);
  // The snapshot table note when the live basis table is not shown (mirrors app.js boot()).
  const fallbackNote = snap
    ? `Recorded snapshot${snapNote(snap).slice('recorded snapshot'.length)}; ${api.mode === 'live' || api.mode === 'stale' ? 'the live basis table is not available' : 'the live API is unreachable'}.`
    : null;

  return (
    <>
      <Header />
      <main>
        <Hero
          symbol={symbol}
          latest={latest.data ?? null}
          latestAt={latest.dataUpdatedAt}
          session={session.data ?? null}
          snapshot={snap}
        />
        <Instrument
          payload={apiChart.data ?? staticChart.data ?? null}
          symbol={symbol}
          onSymbolChange={setSymbol}
          nothingLoaded={nothingLoaded}
        />
        <Ticker latest={latest.data ?? null} snapshot={snap} />
        <Gap snapshot={snap} basis={apiOn() ? (basis.data ?? null) : null} fallbackNote={fallbackNote} />
        <Contracts />
        <Who />
        <VerifyToken />
        <FeeQuote />
        <FeeTransparency />
        <Check snapshot={snap} />
        <Census payload={apiOn() ? (census.data ?? null) : null} unavailable={!apiOn() || census.isError || census.failureCount > 0} />
        <Faq />
        <Status />
      </main>
      <Footer />
    </>
  );
}
